import { auth, app } from '@/firebase'
import { getFunctions, httpsCallable } from 'firebase/functions'
const local = import.meta.env.DEV && import.meta.env.VITE_COMPLIANCE_LOCAL === 'true'
export async function api(route, body) {
 if (!local) { const call = httpsCallable(getFunctions(app, 'us-central1'), 'complianceCommand'); return (await call({route, ...(body?{body}:{})})).data }
 const token=await auth.currentUser?.getIdToken()
 if(!token)throw Error('Sign in first')
 const response=await fetch(`/api/compliance/${route}`,{method:body?'POST':'GET',headers:{Authorization:`Bearer ${token}`,'Content-Type':'application/json'},...(body?{body:JSON.stringify(body)}:{})})
 if (!response.headers.get('content-type')?.includes('application/json')) throw Error('The local compliance API is unavailable. Restart the compliance preview server and reload.')
 const data=await response.json();if(!response.ok)throw Error(data.error||'Compliance request failed');return data
}
export async function upload(communityId,file,caseId='') {
 if(!file?.size)throw Error('Choose an evidence file')
 if(file.size>10*1024*1024)throw Error('Maximum file size is 10 MB')
 const base64=await new Promise((resolve,reject)=>{const r=new FileReader();r.onload=()=>resolve(r.result.split(',')[1]);r.onerror=reject;r.readAsDataURL(file)})
 return api(`${communityId}/upload`,{base64,name:file.name,type:file.type,caseId})
}
export async function openEvidence(e) {
 if(!e.data?.startsWith('/api/compliance/')){window.open(e.data,'_blank','noopener,noreferrer');return}
 if (!local) { const result = await api(e.data.replace('/api/compliance/', '')); const bytes=Uint8Array.from(atob(result.base64),c=>c.charCodeAt(0)); saveEvidence(new Blob([bytes],{type:result.type}),result.name||e.name); return }
 const token=await auth.currentUser.getIdToken();const r=await fetch(e.data,{headers:{Authorization:`Bearer ${token}`}});if(!r.ok)throw Error('Unable to load evidence');saveEvidence(await r.blob(),e.name)
}

function saveEvidence(blob,name) {
 const url=URL.createObjectURL(blob),link=document.createElement('a')
 link.href=url;link.download=name;document.body.appendChild(link);link.click();link.remove()
 setTimeout(()=>URL.revokeObjectURL(url),60000)
}
